
import { call, put } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError,
} from '../../common/client/sagas/common';

import { knDataExec } from '../serverApi/project';

export const GET_OPSUB_ACTION_TYPE = createActionTypes('opsub/GET');

export function* workGetOpsub(options, actionType, action) {
    try {
        yield call(clearActionType);
        yield put({type: actionType.LOADING});
        const data = yield call(
            knDataExec,
            options.serverApi,
            {
                operation: GET_OPSUB_ACTION_TYPE.DEFAULT,
                token: action.token,
                projectId: action.projectId,
                katuzeKod: action.katuzeKod,
                isknDate: action.isknDate
            }
        );
        yield put({type: actionType.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, actionType);
    }
}
